// Shop platform types for roaster inventory (issue #278). Mirrors
// SHOP_PLATFORMS in apps/api-cf/src/common/helpers/shop-platform.ts — keep the
// two in sync. An unset platform is represented as null (never a member here).
export const ROASTER_PLATFORMS = [
  { id: 'shopify', label: 'Shopify' },
  { id: 'woocommerce', label: 'WooCommerce' },
  { id: 'squarespace', label: 'Squarespace' },
  { id: 'wix', label: 'Wix' },
  { id: 'snipcart', label: 'Snipcart' },
  { id: 'custom', label: 'Custom' },
  { id: 'dak', label: 'Dak' },
  { id: 'doubleshot', label: 'Doubleshot' },
  { id: 'white-label', label: 'White Label' },
] as const;

export type RoasterPlatform = (typeof ROASTER_PLATFORMS)[number]['id'];

// Platforms the crawler has a processor for. Mirrors PROCESSABLE_PLATFORMS in
// apps/api-cf/src/backstage/sourcing/crawler/processors/registry.ts — the others are valid to store
// but produce no crawl runs (POST /admin/crawl/:id 400s with "unsupported").
export const CRAWLABLE_PLATFORMS: readonly string[] = [
  'shopify',
  'woocommerce',
  'dak',
  'doubleshot',
  'white-label',
];

export function isPlatformCrawlable(id: string | null): boolean {
  return id !== null && CRAWLABLE_PLATFORMS.includes(id);
}

export function platformLabel(id: string | null): string {
  return ROASTER_PLATFORMS.find((p) => p.id === id)?.label ?? 'Unknown';
}

// Strips the scheme (and any trailing slash) for compact display, matching the
// design. The stored value keeps its full https:// form.
export function displayHost(url: string): string {
  return url.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
}
